import(/* webpackMode: "eager" */ "/vercel/path0/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalendarView"] */ "/vercel/path0/src/app/v1/[communitySlug]/_components/CalendarView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommunityDetailsHeader"] */ "/vercel/path0/src/app/v1/[communitySlug]/_components/CommunityDetailsHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabSwitcher"] */ "/vercel/path0/src/app/v1/[communitySlug]/_components/TabSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/v1/[communitySlug]/_components/WaitlistCommunity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/v1/[communitySlug]/propose/_components/PromptProposeModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarItemsProvider"] */ "/vercel/path0/src/app/v1/[communitySlug]/providers/SidebarItemsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/v3/community-components/CommunityEventFeed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/v3/layout/CommunityViewLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EventFilterProvider"] */ "/vercel/path0/src/contexts/EventSearchContext.tsx");
